import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Ticket } from 'lucide-react';
import { SideDrawer, ProgressBar } from '../SideDrawer';
import { Spinner, ErrorBanner } from '../ReportTableKit';

const API = process.env.REACT_APP_BACKEND_URL;
const dash = v => (v === null || v === undefined || v === '' ? '—' : v);
const PROFILE = [['partner_name', 'Partner'], ['partner_one_id', 'Partner One ID'], ['domain', 'Domain'], ['domain_type', 'Domain Type'],
  ['user_type', 'Type'], ['platform_type', 'Platform'], ['region', 'Region']];

function Section({ title, count, children }) {
  return (
    <div style={{ marginBottom: 22 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: '#0f172a', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>
        {title} <span style={{ color: '#64748b' }}>({count})</span>
      </div>
      {children}
    </div>
  );
}

function VoucherList({ vouchers }) {
  return (
    <div className="table-container"><div className="table-scroll" style={{ overflowX: "auto" }}>
      <table data-testid="learner-voucher-table">
        <thead><tr>{['Campaign', 'Course', 'Type', 'Code', 'Assigned', 'Expiry', 'Email Sent', 'Status'].map(h => <th key={h}>{h}</th>)}</tr></thead>
        <tbody>
          {vouchers.map(v => (
            <tr key={v.id} data-testid={`learner-voucher-${v.id}`} style={{ fontSize: 12 }}>
              <td style={{ minWidth: 220 }}>{dash(v.campaign)}</td><td style={{ minWidth: 260 }}>{dash(v.course_title)}</td>
              <td>{dash(v.voucher_type)}</td><td style={{ fontFamily: 'monospace' }}>{dash(v.voucher_code)}</td>
              <td style={{ whiteSpace: 'nowrap' }}>{dash(v.assigned_at)}</td><td style={{ whiteSpace: 'nowrap' }}>{dash(v.expiry_date)}</td>
              <td style={{ whiteSpace: 'nowrap' }}>{v.email_sent}</td><td style={{ whiteSpace: 'nowrap' }}>{dash(v.status)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div></div>
  );
}

function CourseList({ courses }) {
  return (
    <div className="table-container"><div className="table-scroll" style={{ overflowX: "auto" }}>
      <table data-testid="learner-course-table">
        <thead><tr>{['Course', 'Language', 'Enrolled', 'Last Visited', 'Progress', 'Completed'].map(h => <th key={h}>{h}</th>)}</tr></thead>
        <tbody>
          {courses.map(c => (
            <tr key={c.course_id} data-testid={`learner-course-${c.course_id}`} style={{ fontSize: 12 }}>
              <td style={{ minWidth: 220 }}>{dash(c.course_name)}{c.deactivated && <span style={{ marginLeft: 6, color: '#b91c1c', fontSize: 10 }}>(deactivated)</span>}</td>
              <td>{dash(c.language)}</td>
              <td style={{ whiteSpace: 'nowrap' }}>{dash(c.enrolled_at)}</td><td style={{ whiteSpace: 'nowrap' }}>{dash(c.last_visited_at)}</td>
              <td>{c.progress_pct === null ? '—' : <ProgressBar pct={c.progress_pct} />}</td>
              <td style={{ whiteSpace: 'nowrap' }}>{dash(c.completed_at)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div></div>
  );
}

export function VoucherLearnerDrawer({ lmsId, onClose }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/vouchers/issuance/learner/${encodeURIComponent(lmsId)}`, { withCredentials: true })
      .then(r => setData(r.data)).catch(() => setError('Could not load this learner.'));
  }, [lmsId]);

  const p = data?.profile || {};
  return (
    <SideDrawer testId="voucher-learner-drawer" icon={Ticket} kicker={`LMS ID ${lmsId}`} width={1100} onClose={onClose}
      title={p.student_name || 'Learner'} subtitle={p.student_email}>
      {error && <ErrorBanner message={error} testId="voucher-learner-error" />}
      {!data && !error && <Spinner />}
      {data && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0,1fr))', gap: 10, marginBottom: 22 }} data-testid="learner-profile">
            {PROFILE.map(([k, l]) => (
              <div key={k} style={{ background: '#f8fafc', borderRadius: 8, padding: '8px 10px' }}>
                <div style={{ fontSize: 10, color: '#64748b', textTransform: 'uppercase', fontWeight: 600 }}>{l}</div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#0f172a', wordBreak: 'break-word' }}>{dash(p[k])}</div>
              </div>
            ))}
          </div>
          <Section title="Vouchers" count={data.vouchers.length}><VoucherList vouchers={data.vouchers} /></Section>
          <Section title="Course history (voucher courses)" count={data.courses.length}><CourseList courses={data.courses} /></Section>
        </>
      )}
    </SideDrawer>
  );
}
